class Select {
  constructor(node) {
    this.node = node;

    this.handleChange = this.handleChange.bind(this);

    $(this.node).change(this.handleChange);
    this.calculateWidth(this.node);
  }

  handleChange(event) {
    const $this = $(this.node);
    const selectedIndex = $this.prop('selectedIndex');

    this.calculateWidth(this.node);

    if (selectedIndex !== 0) {
      $this.addClass('select--selected');
    } else {
      $this.removeClass('select--selected');
    }
  }

  calculateWidth() {
    const $this = $(this.node);
    const $selected = $this.children('option:selected');
    const $tmpSelect = $(
      `<select class="select select--temp"><option>${$selected.text()}</option></select>`
    ).insertAfter($this);

    $this.width($tmpSelect.width() + 3);

    $tmpSelect.remove();
  }
}

export default () => {
  const selectNodes = Array.from(document.querySelectorAll('.js-select'));

  if (!selectNodes.length) {
    return;
  }

  selectNodes.forEach(node => {
    window.selects = new Select(node);
  });
};



// WEBPACK FOOTER //
// ./assets/scripts/components/select.js